import { Tooltip } from '~/components';
import { useIntegrations } from '~/contexts';
import { accountingProviders } from '~/lookups';
import qboIcon from '~/assets/public/qbo-icon.png';
import xeroIcon from '~/assets/public/xero-icon.png';
import React from 'react';
import styled from 'styled-components';

const icons = { qbo: qboIcon, xero: xeroIcon };

const Wrapper = styled.div`
  width: 1rem;
  height: 1rem;
  margin-left: 0.5rem;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};
`;

const Image = styled.img`
  width: 1rem;
  height: 1rem;
`;

function getDeepLink(creditNote, integrations) {
  switch (creditNote.accountingProvider) {
    case 'xero': {
      if (!creditNote.xeroCreditNoteId) return null;
      const orgCode = integrations.xero?.find((c) => c.id === creditNote.accountingConnectionId)?.orgCode;
      return orgCode
        ? `https://go.xero.com/organisationlogin/default.aspx?shortcode=${orgCode}&redirecturl=/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${creditNote.xeroCreditNoteId}`
        : `https://go.xero.com/AccountsReceivable/ViewCreditNote.aspx?creditNoteID=${creditNote.xeroCreditNoteId}`;
    }
    default:
      return null;
  }
}

export default function CreditNoteSyncIndicator({ creditNote, message }) {
  const integrations = useIntegrations();
  if (!creditNote.accountingProvider) return null;
  const accountingProviderName = accountingProviders[creditNote.accountingProvider].name;

  const deepLink = getDeepLink(creditNote, integrations);
  const defaultMessage = `This credit note is in ${creditNote.accountingConnectionName || accountingProviderName}.`;

  const handleClick = deepLink
    ? (event) => {
        event.stopPropagation();
        window.open(deepLink, '_blank');
      }
    : undefined;

  return (
    <Wrapper $clickable={!!deepLink} onClick={handleClick}>
      <Tooltip message={message ?? defaultMessage}>
        <Image src={icons[creditNote.accountingProvider]} />
      </Tooltip>
    </Wrapper>
  );
}
